import { render, staticRenderFns } from "./ProfileContent.vue?vue&type=template&id=0875db88&scoped=true&"
import script from "./ProfileContent.vue?vue&type=script&lang=js&"
export * from "./ProfileContent.vue?vue&type=script&lang=js&"
import style0 from "./ProfileContent.vue?vue&type=style&index=0&id=0875db88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875db88",
  null
  
)

export default component.exports